import { MailThreadsFilterKey } from 'types';

export const mailThreadFilters: Record<MailThreadsFilterKey, MailThreadsFilterKey> = {
    type: 'type',
    search: 'search',
};
